if (!customElements.get('personalization-popup')) {
    customElements.define(
      'personalization-popup',
      class PersonalizationPopup extends ModalDialog {
        constructor() {
          super();
          this.input = this.querySelector("[data-name-input]");
          this.name = this.querySelector("[data-name-preview]");
          this.confirmButton = this.querySelector("[data-confirm]");
          this.cancelButton = this.querySelector("[data-cancel]");
          this.errors = this.querySelector("[data-errors]");

          this.nameLineProperty = document.getElementById("nameLineProperty");
          this.sectionId = null;
          this.atcButton = null;

          this.image = this.querySelector("[data-personalization-image]");
          this.imageEmpty = this.querySelector("[data-personalization-image-empty]");
        }
  
        connectedCallback() {
          this.input.addEventListener('input', this.nameInputChanged.bind(this));
          this.confirmButton.addEventListener('click', this.confirm.bind(this));
          this.cancelButton.addEventListener('click', this.cancel.bind(this));
        }

        hide() {
          super.hide();
        }
  
        show(opener) {
          this.sectionId = opener.dataset.sectionId;
          this.atcButton = document.querySelector(`#ProductSubmitButton-${ this.sectionId }`);

          super.show(opener);
        }
  
        nameInputChanged() {
          this.name.innerHTML = this.input.value;

          let deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
          let fontSize;
          if(this.input.value.length > 0) {
            this.image.classList.add("hidden");
            this.imageEmpty.classList.remove("hidden");
          }
          else {
            this.image.classList.remove("hidden");
            this.imageEmpty.classList.add("hidden");
          }
          
          if(this.input.value.length > 15) {
            fontSize = deviceWidth > 750 ? (32 - (27 - this.input.value.length)) : (22 - (20 - this.input.value.length));
            this.name.style = `font-size: ${ fontSize }px`
          }
          else if(this.input.value.length > 10) {
            fontSize = deviceWidth > 750 ? (32 - (20 - this.input.value.length)) : (24 - (20 - this.input.value.length));
            this.name.style = `font-size: ${fontSize }px`
          }
          else {
            this.name.style = "";
          }
        }

        confirm() {
          if(!this.isValid() || !this.atcButton) return;
          this.nameLineProperty.value = this.input.value;
          this.atcButton.click();

          setTimeout(() => {
            this.clearName();
          }, 2000);
          this.hide();
        }

        cancel() {
          if(!this.atcButton) return;
          this.atcButton.click();

          setTimeout(() => {
            this.clearName();
            this.clearErrors();
          }, 2000);
          this.hide();
        }

        isValid() {
          if(this.input.value === null || this.input.value === '') {
            this.renderErrors();
            return false;
          }

          this.clearErrors();
          return true;
        }

        renderErrors() {
          this.input.classList.add('invalid');
          this.errors.classList.add('has-errors');
        }

        clearErrors() {
          this.input.classList.remove('invalid');
          this.errors.classList.remove('has-errors');
        }

        clearName() {
          this.input.value = "";
          this.nameLineProperty.value = "";
          this.name.innerHTML = "";
        }
      }
    );
  }
  